<div class="details-body-wrapper">
  <ng-container *ngIf="isLoadingGeneral">
    <app-loader-spinner-general
      [repeat]="3"
      [loadingType]="LoadingType.INFO"
    ></app-loader-spinner-general>
  </ng-container>

  <div *ngIf="!isLoadingGeneral && fundingRequest">
    <div class="details-actions">
      <button
        *ngIf="getAvailableAction('fund') as fundAction"
        type="button"
        class="btn orange-bg fl-r"
        [disabled]="isUpdatingStatus"
        (click)="markAsFunded()"
      >
        {{ isUpdatingStatus ? "Saving..." : fundAction.label }}
      </button>
      <div class="clear"></div>
    </div>

    <div class="details-panels">
      <section class="white-box-wrapper details-panel">
        <div class="white-box-row">
          <div class="white-box-header">
            <div class="medium-title fl-l">Funding request details</div>
          </div>
          <div class="clear"></div>
          <div class="white-box-body">
            <div class="detail-grid">
              <div class="detail-field">
                <span class="font-weight-bold">
                  {{ "GENERALS.AMOUNT" | translate }}
                </span>
                <p class="case-label m-t-10">
                  {{ fundingRequest.amount | number : "1.2-2" }}
                </p>
              </div>

              <div class="detail-field">
                <span class="font-weight-bold">
                  {{ "GENERALS.CURRENCY" | translate }}
                </span>
                <p class="case-label m-t-10">
                  {{ fundingRequest.currency | notAvailable }}
                </p>
              </div>

              <div class="detail-field">
                <span class="font-weight-bold">Funds needed by</span>
                <p class="case-label m-t-10">
                  {{
                    fundingRequest.funds_needed_by
                      ? (fundingRequest.funds_needed_by | date)
                      : "N/A"
                  }}
                </p>
              </div>

              <div class="detail-field">
                <span class="font-weight-bold">
                  {{ "GENERALS.STATUS" | translate }}
                </span>
                <p class="case-label m-t-10">
                  {{ fundingRequest.status | titlecase }}
                </p>
              </div>

              <div class="detail-field">
                <span class="font-weight-bold">
                  {{ "GENERALS.CREATED-AT" | translate }}
                </span>
                <p class="case-label m-t-10">
                  {{
                    fundingRequest.created_at
                      ? (fundingRequest.created_at | date : "medium")
                      : "N/A"
                  }}
                </p>
              </div>

              <div class="detail-field">
                <span class="font-weight-bold">
                  {{ "GENERALS.UPDATED-AT" | translate }}
                </span>
                <p class="case-label m-t-10">
                  {{
                    fundingRequest.updated_at
                      ? (fundingRequest.updated_at | date : "medium")
                      : "N/A"
                  }}
                </p>
              </div>

              <div class="detail-field detail-field-full">
                <span class="font-weight-bold">
                  {{ "GENERALS.NOTE" | translate }}
                </span>
                <p class="case-label m-t-10">
                  {{ fundingRequest.note | notAvailable }}
                </p>
              </div>
            </div>

            <div class="account-details-section">
              <div class="font-weight-bold account-details-title">
                Account details
              </div>

              <ng-container
                *ngIf="
                  fundingRequest.account?.account_details?.length;
                  else noAccountDetails
                "
              >
                <div class="account-details-list">
                  <div
                    class="account-details-card"
                    *ngFor="
                      let accountDetail of fundingRequest.account
                        ?.account_details;
                      let index = index
                    "
                  >
                    <div class="account-details-grid">
                      <div class="detail-field">
                        <span class="font-weight-bold">Account name</span>
                        <p class="case-label m-t-10">
                          {{ accountDetail.account_name | notAvailable }}
                        </p>
                      </div>

                      <div class="detail-field">
                        <span class="font-weight-bold"
                          >Account number type</span
                        >
                        <p class="case-label m-t-10">
                          {{ accountDetail.account_number_type | notAvailable }}
                        </p>
                      </div>

                      <div class="detail-field">
                        <span class="font-weight-bold">Account number</span>
                        <p class="case-label m-t-10">
                          {{ accountDetail.account_number | notAvailable }}
                        </p>
                      </div>

                      <div class="detail-field">
                        <span class="font-weight-bold"
                          >Bank identifier type</span
                        >
                        <p class="case-label m-t-10">
                          {{
                            accountDetail.bank_identifier_type | notAvailable
                          }}
                        </p>
                      </div>

                      <div class="detail-field">
                        <span class="font-weight-bold">Bank identifier</span>
                        <p class="case-label m-t-10">
                          {{ accountDetail.bank_identifier | notAvailable }}
                        </p>
                      </div>

                      <div class="detail-field">
                        <span class="font-weight-bold">Account address</span>
                        <p class="case-label m-t-10">
                          {{ accountDetail.account_address | notAvailable }}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </ng-container>

              <ng-template #noAccountDetails>
                <p class="case-label m-t-10">
                  {{ "GENERALS.NO-ITEMS-DISPLAY" | translate }}
                </p>
              </ng-template>
            </div>
          </div>
        </div>
      </section>

      <section class="white-box-wrapper details-panel">
        <div class="white-box-row">
          <div class="white-box-header">
            <div class="medium-title fl-l">Attachments</div>
          </div>
          <div class="clear"></div>
          <div class="white-box-body">
            <ng-container
              *ngIf="fundingRequest.attachments?.length; else noAttachments"
            >
              <div
                class="attachment-item"
                *ngFor="let attachment of fundingRequest.attachments"
              >
                <p class="case-label">
                  <a
                    *ngIf="attachment.file_path"
                    [href]="attachment.file_path"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {{ attachment.name | notAvailable }}
                  </a>
                  <ng-container *ngIf="!attachment.file_path">
                    {{ attachment.name | notAvailable }}
                  </ng-container>
                </p>
              </div>
            </ng-container>

            <ng-template #noAttachments>
              <p class="case-label">
                {{ "GENERALS.NO-ITEMS-DISPLAY" | translate }}
              </p>
            </ng-template>
          </div>
        </div>
      </section>
    </div>
  </div>
</div>
